// exclude-from-index
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { SVGIcon } from '@custom-components';
import { withTheme } from 'styled-components';
import { themePropType } from '@themes';
import { StyledMenuItem, StyledMenu, StyledMenuLabel } from './OrgSelect.styles';

class OrgSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedOrg: props.userCurrentOrganization,
      anchorEl: null
    };
  }

  // used to update the current selected organization once callback has executed and new value is passed back.
  static getDerivedStateFromProps(nextProps, prevState) {
    const { selectedOrg } = prevState;
    const { userCurrentOrganization } = nextProps;

    if (selectedOrg !== userCurrentOrganization) {
      return { selectedOrg: userCurrentOrganization };
    }
    return null;
  }

  // click to open menu
  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  // close menu
  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  // function returns the newly selected organization to the callback.
  handleChange = (orgId) => {
    const { organizations, organizationChange } = this.props;
    const { selectedOrg } = this.state;

    // if the new one isn't the same as the old; update.
    if (orgId !== selectedOrg) {
      const changedOrg = organizations.find((organization) => organization.id === orgId).id || 'unknown';
      organizationChange(changedOrg);
    }
  };

  renderOrg() {
    const { organizations, showIcon, iconRotation, theme } = this.props;
    const { selectedOrg, anchorEl } = this.state;

    if (organizations.length > 0 && selectedOrg) {
      if (organizations.length === 1) {
        return <StyledMenuLabel title="Select Organization">{organizations[0].name}</StyledMenuLabel>;
      }

      const currentOrg = organizations.find((orgRole) => orgRole.id === selectedOrg);

      /* eslint-disable jsx-a11y/click-events-have-key-events */
      /* eslint-disable jsx-a11y/no-static-element-interactions */
      return (
        <div>
          <StyledMenuLabel
            aria-owns={anchorEl ? 'simple-menu' : null}
            aria-haspopup="true"
            onClick={this.handleClick}
            title="Select Organization"
          >
            {currentOrg ? currentOrg.name : ''}
            {showIcon && <SVGIcon selectedIcon="arrow" rotate={iconRotation} iconColor={theme.lightText} />}
          </StyledMenuLabel>
          <StyledMenu id="simple-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={this.handleClose}>
            {[
              organizations.map((org) => (
                <StyledMenuItem
                  onClick={() => this.handleChange(org.id)}
                  selected={org.id === selectedOrg}
                  title={org.name}
                >
                  {org.name}
                </StyledMenuItem>
              ))
            ]}
          </StyledMenu>
        </div>
      );
    }

    return null;
  }

  render() {
    return <>{this.renderOrg()}</>;
  }
}

OrgSelect.propTypes = {
  /**
   * Array of organization objects containing their ID and front facing name. Needs to be passed with usersCurrentOrganization.
   */
  organizations: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string })),
  /**
   * String ID of the users currently assigned organization, needs to match an organization passed within organizations array.
   */
  userCurrentOrganization: PropTypes.number,
  /**
   * Function passed to callback so we can sync all areas showing current organization when users select a new one.
   */
  organizationChange: PropTypes.func,
  /**
   * Numerical value 360deg to determine rotation of the carrot icon next to the select.
   */
  iconRotation: PropTypes.number,
  /**
   * Bool determining whether to show the carrot or not.
   */
  showIcon: PropTypes.bool,
  /**
   * theme prop passed through
   */
  theme: themePropType
};

OrgSelect.defaultProps = {
  organizations: [],
  userCurrentOrganization: undefined,
  organizationChange: () => {},
  iconRotation: 0,
  showIcon: true,
  theme: {}
};

const ComposedOrgSelect = withTheme(OrgSelect);
export default ComposedOrgSelect;
